<template>
  <div class="add-instagram-container">
    <div class="top-container">
      <el-popover
        placement="right-end"
        width="230"
        v-model="show"
        trigger="click"
      >
        <div class="platform-list-container">
          <div class="platform-item" @click="addInsBtnClick">
            <div class="icon ins"></div>
            <div class="text">Instagram</div>
            <div class="right-icon"></div>
          </div>
          <div class="platform-item" @click="addFbPageBtnClick">
            <div class="icon fb"></div>
            <div class="text">Facebook Page</div>
            <div class="right-icon"></div>
          </div>
          <div class="platform-item" @click="addFbGroupBtnClick">
            <div class="icon fb-group"></div>
            <div class="text">Facebook Group</div>
            <div class="right-icon"></div>
          </div>
          <div class="platform-item" @click="addTwitterBtnClick">
            <div class="icon twitter"></div>
            <div class="text">Twitter</div>
            <div class="right-icon"></div>
          </div>
        </div>
        <div slot="reference" class="add-user-btn">
          <div class="icon"></div>
          <div class="text">Add Social Account</div>
        </div>
      </el-popover>
      <!-- <div class="add-user-btn" @click="addInsUser">
        <div class="icon"></div>
        <div class="text">Add Social Account</div>
      </div> -->
    </div>
    <div class="main-container">
      <el-table class="table" :data="list">
        <el-table-column
          label="Social Account"
          :show-overflow-tooltip="true"
          min-width="230"
        >
          <template slot-scope="scope">
            <div class="image-container">
              <div
                :key="scope.row.image"
                class="image"
                v-lazy:background-image="scope.row.image"
              >
                <div
                  v-if="scope.row.socialNetwork === 1"
                  class="ins-user-icon"
                ></div>
                <div
                  v-if="scope.row.socialNetwork === 2"
                  class="fb-page-user-icon"
                ></div>
                <div
                  v-if="scope.row.socialNetwork === 3"
                  class="fb-group-user-icon"
                ></div>
                <div
                  v-if="scope.row.socialNetwork === 4"
                  class="tw-user-icon"
                ></div>
              </div>
              <div class="username">{{ scope.row.username }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Schedules/m"
          prop="description"
          :show-overflow-tooltip="true"
          min-width="180"
        >
        </el-table-column>
        <el-table-column
          label="Admin"
          prop="adminText"
          :show-overflow-tooltip="true"
          :min-width="adminWidth"
        >
        </el-table-column>
        <el-table-column
          label="Member"
          :show-overflow-tooltip="true"
          min-width="230"
          prop="memberList"
        >
          <template slot-scope="scope">
            <div
              class="member-container"
              v-for="member in scope.row.memberList"
              :key="member"
            >
              {{ member }}
            </div>
            <div
              class="member-container"
              v-if="scope.row.memberList.length === 0"
            >
              --
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="80">
          <template slot-scope="scope">
            <div
              v-if="!scope.row.isMember"
              style="text-align: right; padding-right: 10px"
            >
              <remove-btn @click="remove(scope.row)"></remove-btn>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";
import { showErrorMsg } from "../../utils/errors";
import { remove } from "../../service/publisher";
import removeBtn from "../../components/common/button/Remove";
import _ from "lodash";

export default {
  name: "AccountAddInstagramPage",
  components: {
    removeBtn,
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    /**
     * 添加点击事件
     */
    addInsBtnClick() {
      this.show = false;
      this.platformModal = false;
      this.$bus.$emit("showAddIns", {});
    },
    addFbPageBtnClick() {
      this.show = false;
      this.platformModal = false;
      this.$bus.$emit("showAddFacebookPage", { homeLogin: true });
    },
    addFbGroupBtnClick() {
      this.show = false;
      this.platformModal = false;
      this.$bus.$emit("showAddFacebookGroup", {});
    },
    addTwitterBtnClick() {
      this.show = false;
      this.platformModal = false;
      this.$bus.$emit("showAddTwitter", {});
    },
    /**
     * 删除选项
     * @param item 对应项
     */
    async remove(item) {
      const loading = this.$loading();
      try {
        await remove({ id: item.id });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    /**
     * 添加按钮点击事件
     */
    addInsUser() {
      this.$bus.$emit("showAddIns", {});
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    /**
     * 计算列表
     * @returns {Array}
     */
    list() {
      const list = this.user.linkedInstagramList.map((ins) => {
        const linked = _.cloneDeep(ins);
        linked.adminText = ins.isMember ? ins.member : "me";
        linked.memberList = [];
        if (!ins.isMember) {
          // 计算当前publisher分享的member账号
          this.user.teamMemberList.forEach((team) => {
            const member = team.publishers.find(
              (p) => p.publisherId === linked.publisherId
            );
            if (member) {
              linked.memberList.push(team.memberEmail);
            }
          });
        }
        return linked;
      });
      return list;
    },
    /**
     * 是否至少存在一个member，如果存在则加大member宽度
     */
    adminWidth() {
      return this.user.linkedInstagramList.findIndex((l) => l.isMember) === -1
        ? "100"
        : "230";
    },
  },
};
</script>
<style scoped lang="less">
.platform-list-container {
  padding: 10px 0;
  .platform-item {
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
    .icon {
      height: 22px;
      width: 22px;
      background-size: contain;
      &.ins {
        background-image: url("../../../public/images/common/list_ins@3x.png");
      }
      &.fb {
        background-image: url("../../../public/images/common/list_fb@3x.png");
      }
      &.fb-group {
        background-image: url("../../../public/images/common/list_fb_group@3x.png");
      }
      &.twitter {
        background-image: url("../../../public/images/common/list_twitter@3x.png");
      }
    }
    .right-icon {
      height: 18px;
      width: 10px;
      background-size: contain;
      background-image: url("../../../public/images/schedule_posts/Date_Right@3x.png");
    }
    .text {
      flex: 1;
      padding-left: 10px;
      font-size: 16px;
    }
  }
}
.image-container {
  display: flex;
  align-items: center;
  overflow: hidden;
  .image {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-position: center;
    background-size: cover;
    position: relative;
  }
  .username {
    margin-left: 15px;
    font-size: 15px;
    overflow: hidden;
    flex: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.member-container {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.remove-container {
  height: 130px;
  padding: 30px;
  .message {
    font-size: 14px;
    text-align: center;
    width: 100%;
  }
  .btn-group {
    display: flex;
    margin-top: 35px;
    justify-content: space-between;
    .btn {
      width: 88px;
      height: 28px;
      background-color: #e72955;
      border-radius: 2px;
      font-size: 14px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &:active,
      &:hover {
        opacity: 0.8;
      }
    }
  }
}

.add-instagram-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  flex: 1;
  min-width: 1px;
  .top-container {
    height: 80px;
    border-bottom: 1px solid #e5e5e5;
    display: flex;
    align-items: center;
    .add-user-btn {
      margin-left: 60px;
      display: flex;
      align-items: center;
      font-weight: 500;
      cursor: pointer;
      &:active,
      &:hover {
        opacity: 0.8;
      }
      .icon {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-image: url(../../../public/images/schedule_posts/Add_Detail@3x.png);
        background-size: contain;
      }
      .text {
        font-size: 16px;
        margin-left: 10px;
      }
    }
  }
  .main-container {
    padding: 30px 60px;
    flex: 1;
    overflow: auto;
    .list-main-container {
      padding-top: 13px;
    }
  }
}
</style>
